import type { ActionSource } from "owa-mail-store";
import { getStore as composeStore } from "owa-mail-compose-store";
import { selectPreviousNode } from "owa-mail-actions/lib/selectPreviousNode";
import { getSelectedTableView, isMyOutlookTable } from "owa-mail-list-store";
import type { MyOutlookTableQuery } from "owa-mail-list-store/lib/store/schema/MyOutlookTableQuery";
import { setMyOutlookFullPageShowingMutator } from "owa-personal-os-store/lib/mutators/setShowingInReadingPane";
import { isMyOutlookFullPageShowing } from "owa-personal-os-store/lib/selectors/getReadingPaneState";
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Baseline. Do not copy and paste"
 *	> '../index' import is restricted from being used. */
import { lazyNewMessage } from "../index";
import { shouldPopoutNewMessage } from "../utils/shouldPopoutNewMessage";
import setNewMessageCreationInProgress from "./setNewMessageCreationInProgress";

// VSO 29687: Check if a new message is in the process of being created,
// and if not (or complete), create a new message
export default async function checkAndCreateNewMessage(actionSource: ActionSource, targetId: string | null, eventTimestamp?: number): Promise<void> {
    if (!composeStore().newMessageCreationInProgress) {
        const selectedTableQuery = getSelectedTableView()?.tableQuery;
        const myOutlookMailboxInfo = isMyOutlookTable(selectedTableQuery)
            ? (selectedTableQuery as MyOutlookTableQuery).mailboxInfo
            : undefined;
        
        if (isMyOutlookFullPageShowing() || myOutlookMailboxInfo) {
            setMyOutlookFullPageShowingMutator(false);
            selectPreviousNode("MyOutlookFolderPane");
        }
        
        setNewMessageCreationInProgress(true /*newMessageCreationInProgress*/);
        const shouldPopout = shouldPopoutNewMessage();
        try {
            return lazyNewMessage.importAndExecute(actionSource, {
                targetId: targetId ?? undefined,
                mailboxInfo: myOutlookMailboxInfo,
                isPopout: shouldPopout,
                eventTimestamp,
            });
        }
        finally {
            setNewMessageCreationInProgress(false /*newMessageCreationInProgress*/);
        }
    }
    
    return Promise.resolve();
}
